import React, { useState } from "react";
import TabPanel from "../property/TabPanel";
import FolderStructure from "../../tree/FolderStructure";
import { Notes } from "../property/Notes";
import { Tab, Tabs } from "@mui/material";
import { DatePicker } from "../genericFunctions.js/DatePicker";
import { PropertyNotifications } from "../property/PropertyNotifications";
import { Interactions } from "../tenant/Interactions";

export const AddLeadForm = () => {
  const [tabValue, setTabValue] = useState(0);
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };
  return (
    <>
      <form
        className="w-full"
        id="add-lead-form"
        // onSubmit={formSubmitHandler}
      >
        <Tabs
          value={tabValue}
          onChange={handleChange}
          aria-label="basic tabs example"
          variant="scrollable"
          scrollButtons
          allowScrollButtonsMobile
        >
          <Tab label="Lead Information" {...a11yProps(0)} />
          <Tab label="Notifications" {...a11yProps(1)} />
          <Tab label="Notes & Files" {...a11yProps(2)} />
          <Tab label="Interactions" {...a11yProps(3)} />
        </Tabs>
        <TabPanel value={tabValue} index={0}>
          <div className="md:flex flex-column md:items-center w-[90%] m-auto">
            <div className="w-full">
              <div className="md:flex md:items-center w-1/2  mt-3">
                <div className="md:flex md:w-full">
                  <div className="md:w-auto show-to-tenant">
                    <label className="block tracking-wide text-gray-700 font-bold mb-2 mr-1">
                      Send Notifications
                    </label>
                  </div>
                  <label class="inline-flex relative items-center cursor-pointer">
                    <input
                      type="checkbox"
                      // value={formData?.hoa_show_to_tenant}
                      // onChange={(e) => {
                      //   const checkedValue = e.target.checked === true ? 1 : 0;
                      //   setFormData({
                      //     ...formData,
                      //     hoa_show_to_tenant: checkedValue,
                      //   });
                      // }}
                      class="sr-only peer"
                    />
                    <div class="w-14 h-7 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-auto after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                  </label>
                </div>
              </div>
              <div className="md:flex md:items-center w-full mt-3">
                <div className="md:flex md:items-center w-full md:w-2/12 mb-6">
                  {/* <div className="md:w-1/4">
                      <label className="block capitalize text-gray-700 font-bold mb-2">
                        Prefix:
                      </label>
                    </div> */}
                  <div className="md:w-full">
                    <select
                      className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="user_prefix_id"
                      required={false}
                      // value={formData?.user_prefix_id}
                      // onChange={(e) => {
                      //   setFormData({
                      //     ...formData,
                      //     user_prefix_id: parseInt(e.target.value),
                      //   });
                      // }}
                    >
                      <option value=" ">Select</option>
                      {/* {prefix.map((row) => (
                          <option value={row?.id}>{row?.prefix}</option>
                        ))} */}
                    </select>
                  </div>
                </div>
                <div className="md:flex md:items-center w-full md:w-3/12 mb-6 mx-2">
                  <div className="md:w-1/4">
                    <label className="block capitalize text-gray-700 font-bold mb-2">
                      First
                    </label>
                  </div>
                  <div className="md:w-3/4">
                    <input
                      className="block appearance-none w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="firstname"
                      type="text"
                      placeholder="John"
                      required={false}
                      // value={formData?.firstname}
                      // onChange={(e) => {
                      //   setCreateLog({ ...createLog, firstname: 1 });
                      //   setFormData({ ...formData, firstname: e.target.value });
                      // }}
                    />
                  </div>
                </div>
                <div className="md:flex md:items-center w-full md:w-3/12 mb-6">
                  <div className="md:w-1/3">
                    <label className="block capitalize text-gray-700 font-bold mb-2">
                      Middle
                    </label>
                  </div>
                  <div className="md:w-3/4">
                    <input
                      className="block appearance-none w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="middlename"
                      type="text"
                      placeholder="Ben"
                      required={false}
                      // value={formData?.middlename}
                      // onChange={(e) => {
                      //   setCreateLog({ ...createLog, middlename: 1 });
                      //   setFormData({
                      //     ...formData,
                      //     middlename: e.target.value,
                      //   });
                      // }}
                    />
                  </div>
                </div>
                <div className="md:flex md:items-center w-full md:w-4/12 mb-6 mx-2">
                  <div className="md:w-1/5">
                    <label className="block capitalize text-gray-700 font-bold mb-2">
                      Last
                    </label>
                  </div>
                  <div className="md:w-3/4">
                    <input
                      className="block appearance-none w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="lastname"
                      type="text"
                      placeholder="Deo"
                      required={false}
                      // value={formData?.lastname}
                      // onChange={(e) => {
                      //   setCreateLog({ ...createLog, lastname: 1 });
                      //   setFormData({ ...formData, lastname: e.target.value });
                      // }}
                    />
                  </div>
                </div>
                <div className="md:flex md:items-center w-full md:w-2/12 mb-6">
                  {/* <div className="md:w-1/4">
                      <label className="block capitalize text-gray-700 font-bold mb-2">
                        Suffix:
                      </label>
                    </div> */}
                  <div className="md:w-full">
                    <select
                      className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="user_suffix_id"
                      required={false}
                      // value={formData?.user_suffix_id}
                      // onChange={(e) => {
                      //   setFormData({
                      //     ...formData,
                      //     user_suffix_id: parseInt(e.target.value),
                      //   });
                      // }}
                    >
                      <option value=" ">Select</option>
                      {/* {suffix.map((row) => (
                          <option value={row?.id}>{row?.suffix}</option>
                        ))} */}
                    </select>
                  </div>
                </div>
              </div>
              <div className="md:flex md:items-center w-full mt-3">
                <div className="md:w-1/5">
                  <label className="block capitalize tracking-wide text-gray-700 font-bold mb-2">
                    Company:
                  </label>
                </div>
                <div className="md:w-4/5">
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id="addresses-address-line-1"
                    type="text"
                    placeholder="6284 Locust Road"
                    required={false}
                    // value={formData?.addresses[0]?.address_line1}
                    // onChange={(e) => {
                    //   const addresses = [...tenantAddress];
                    //   addresses[0].address_line1 = e.target.value;
                    //   setCreateLog({...createLog,address_line1:1});
                    //   setTenantAddress(addresses);
                    //   setFormData({ ...formData, addresses: addresses });
                    // }}
                  />
                </div>
              </div>
              <div className="md:flex md:items-center w-full mt-3">
                <div className="md:w-1/5">
                  <label className="block capitalize tracking-wide text-gray-700 font-bold mb-2">
                    Title:
                  </label>
                </div>
                <div className="md:w-4/5">
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id="addresses-address-line-1"
                    type="text"
                    placeholder="6284 Locust Road"
                    required={false}
                    // value={formData?.addresses[0]?.address_line1}
                    // onChange={(e) => {
                    //   const addresses = [...tenantAddress];
                    //   addresses[0].address_line1 = e.target.value;
                    //   setCreateLog({...createLog,address_line1:1});
                    //   setTenantAddress(addresses);
                    //   setFormData({ ...formData, addresses: addresses });
                    // }}
                  />
                </div>
              </div>
              <div className="md:flex md:items-center w-full mt-3">
                <div className="md:w-1/5">
                  <label className="block capitalize tracking-wide text-gray-700 font-bold mb-2">
                    Address Line 1:
                  </label>
                </div>
                <div className="md:w-4/5">
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id="addresses-address-line-1"
                    type="text"
                    placeholder="6284 Locust Road"
                    required={false}
                    // value={formData?.addresses[0]?.address_line1}
                    // onChange={(e) => {
                    //   const addresses = [...tenantAddress];
                    //   addresses[0].address_line1 = e.target.value;
                    //   setCreateLog({...createLog,address_line1:1});
                    //   setTenantAddress(addresses);
                    //   setFormData({ ...formData, addresses: addresses });
                    // }}
                  />
                </div>
              </div>
              <div className="md:flex md:items-center w-full mt-3">
                <div className="md:w-1/5">
                  <label className="block capitalize tracking-wide text-gray-700 font-bold mb-2">
                    Address Line 2:
                  </label>
                </div>
                <div className="md:w-4/5">
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id="addresses-address_line2"
                    type="text"
                    placeholder="Unit #5"
                    // value={formData?.addresses[0]?.address_line2}
                    // onChange={(e) => {
                    //   const addresses = [...tenantAddress];
                    //   setCreateLog({...createLog,address_line2:1});
                    //   addresses[0].address_line2 = e.target.value;
                    //   setTenantAddress(addresses);
                    //   setFormData({ ...formData, addresses: addresses });
                    // }}
                  />
                </div>
              </div>
              <div className="md:flex md:items-center w-full mt-3">
                <div className="md:flex md:items-center w-full md:w-6/12 mb-6">
                  <div className="md:w-1/4">
                    <label className="block capitalize text-gray-700 font-bold mb-2">
                      Country:
                    </label>
                  </div>
                  <div className="md:w-2/4">
                    <select
                      className="block appearance-none w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="addresses-country"
                      type="text"
                      placeholder="Albuquerque"
                      required={false}
                      // value={formData?.addresses[0]?.country}
                      // onChange={(e) => {
                      //   const addresses = [...tenantAddress];
                      //   addresses[0].country = e.target.value;
                      //   setTenantAddress(addresses);
                      //   setCreateLog({...createLog,country:1})
                      //   setFormData({
                      //     ...formData,
                      //     addresses: addresses,
                      //   });
                      //   getStates(e.target.value);
                      // }}
                    >
                      <option value=" ">Select Country</option>
                      {/* {countries?.map((country)=>(
                              <option value={country?.id}>{country?.country}</option>
                            ))} */}
                    </select>
                  </div>
                </div>
                <div className="md:flex md:items-center w-full md:w-6/12 mb-6">
                  <div className="md:w-1/4">
                    <label className="block capitalize text-gray-700 font-bold mb-2">
                      State:
                    </label>
                  </div>
                  <div className="md:w-2/4">
                    <select
                      className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="addresses-state"
                      required={false}
                      // value={formData?.addresses[0]?.state}
                      // onChange={(e) => {
                      //   const addresses = [...tenantAddress];
                      //   addresses[0].state = e.target.value;
                      //   setTenantAddress(addresses);
                      //   setCreateLog({...createLog,state:1})
                      //   setFormData({
                      //     ...formData,
                      //     addresses: addresses,
                      //   });
                      //   getCities(e.target.value);
                      // }}
                    >
                      <option value=" ">Select State</option>
                      {/* {states?.map((state)=>(
                              <option value={state?.id}>{`${state?.state} (${state?.state_code})`}</option>
                            ))} */}
                    </select>
                  </div>
                </div>
              </div>
              <div className="md:flex md:items-center w-full mt-3">
                <div className="md:flex md:items-center w-full md:w-6/12 mb-6">
                  <div className="md:w-1/4">
                    <label className="block capitalize text-gray-700 font-bold mb-2">
                      City:
                    </label>
                  </div>
                  <div className="md:w-2/4">
                    <select
                      className="block appearance-none w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="addresses-city"
                      type="text"
                      placeholder="Albuquerque"
                      required={false}
                      // value={formData?.addresses[0]?.city}
                      // onChange={(e) => {
                      //   setCreateLog({...createLog,city:1})
                      //   const addresses = [...tenantAddress];
                      //   const zip = cities?.map((col) =>{
                      //     if(col?.id == e.target.value)
                      //     {
                      //       return col?.zip_code
                      //     }
                      //   })
                      //   const filteredArr = zip.filter((value) => value !== undefined);
                      //   const zipCode = filteredArr.join(', ');
                      //   addresses[0].city = e.target.value;
                      //   addresses[0].zip_code = zipCode;
                      //   setTenantAddress(addresses);
                      //   setFormData({
                      //     ...formData,
                      //     addresses: addresses,
                      //   });

                      // }}
                    >
                      <option value=" ">Select City</option>
                      {/* {cities?.map((city)=>(
                      <option value={city?.id}>{city?.city}</option>
                    ))} */}
                    </select>
                  </div>
                </div>
                <div className="md:flex md:items-center w-full md:w-6/12 mb-6">
                  <div className="md:w-1/4">
                    <label className="block capitalize text-gray-700 font-bold mb-2">
                      Zip:
                    </label>
                  </div>
                  <div className="md:w-2/4">
                    <input
                      className="block appearance-none w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="grid-zip"
                      type="text"
                      placeholder="90210"
                      required={false}
                      // value={formData?.addresses[0]?.zip_code}
                      // onChange={(e) => {
                      //   const addresses = [...tenantAddress];
                      //   addresses[0].zip_code = e.target.value;
                      //   setTenantAddress(addresses);
                      //   setCreateLog({...createLog,zip_code:1})
                      //   setFormData({
                      //     ...formData,
                      //     addresses: addresses,
                      //   });
                      // }}
                    />
                  </div>
                </div>
              </div>
              {/* </>
                );
              })} */}
              <div className="md:flex md:items-center mt-3">
                <div className="md:w-1/5">
                  <label className="block capitalize tracking-wide text-gray-700 font-bold mb-2">
                    Number 1:
                  </label>
                </div>
                <div className="md:w-3/5">
                  {/* {formData?.numbers[0]?.number_type == 8 ? */}
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id={`tenant-num-l`}
                    type="tel"
                    placeholder="(999) 999-9999"
                    // value={number?.[0]?.phone_number}
                    // onChange={(e) => {
                    //   const phone = [...number];
                    //   setCreateLog({...createLog,phone_number_1:1});
                    //   phone[0].phone_number = e.target.value;
                    //   setNumber(phone);
                    //   setFormData({ ...formData, numbers: phone });
                    // }}
                    // maxLength={ownerSettings?.phone_number_format?.length}
                  />
                  {/* :
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id={`tenant-num-l`}
                    type="tel"
                    placeholder="(999) 999-9999"
                    value={formatPhoneNumber(number?.[0]?.phone_number,ownerSettings?.phone_number_format)}
                    onChange={(e) => {
                      const phone = [...number];
                      setCreateLog({...createLog,phone_number_1:1});
                      phone[0].phone_number = removeNonNumeric(e.target.value);
                      setNumber(phone);
                      setFormData({ ...formData, numbers: phone });
                    }}
                    maxLength={ownerSettings?.phone_number_format?.length}
                  />
                  } */}
                </div>
                <div className="md:w-1/5 pl-3">
                  <select
                    className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id={`tenant-num-1-type`}
                    // value={formData?.numbers[0]?.number_type}
                    // onChange={(e) => {
                    //   setCreateLog({...createLog,number_type_1:1});
                    //   const phone = [...number];
                    //   phone[0].number_type = e.target.value;
                    //   setNumber(phone);
                    //   setFormData({ ...formData, numbers: phone });
                    // }}
                  >
                    <option value=" ">Select Type</option>
                    {/* {numberType?.map((row)=>(
                          <option value={row?.id}>{row?.type}</option>
                        ))} */}
                  </select>
                </div>
              </div>
              <div className="md:flex md:items-center mt-3">
                <div className="md:w-1/5">
                  <label className="block capitalize tracking-wide text-gray-700 font-bold mb-2">
                    Number 2:
                  </label>
                </div>
                <div className="md:w-3/5">
                  {/* {formData?.numbers[1]?.number_type == 8 ? */}
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id={`tenant-num-2`}
                    type="tel"
                    placeholder="(999) 999-9999"
                    // value={number?.[1]?.phone_number}
                    // onChange={(e) => {
                    //   const phone = [...number];
                    //   setCreateLog({...createLog,phone_number_1:1});
                    //   phone[1].phone_number = e.target.value;
                    //   setNumber(phone);
                    //   setFormData({ ...formData, numbers: phone });
                    // }}
                    // maxLength={ownerSettings?.phone_number_format?.length}
                  />
                  {/* :
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id={`tenant-num-2`}
                    type="tel"
                    placeholder="(999) 999-9999"
                    value={formatPhoneNumber(number?.[1]?.phone_number,ownerSettings?.phone_number_format)}
                    onChange={(e) => {
                      const phone = [...number];
                      setCreateLog({...createLog,phone_number_1:1});
                      phone[1].phone_number = removeNonNumeric(e.target.value);
                      setNumber(phone);
                      setFormData({ ...formData, numbers: phone });
                    }}
                    maxLength={ownerSettings?.phone_number_format?.length}
                  />
                  } */}
                </div>
                <div className="md:w-1/5 pl-3">
                  <select
                    className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id={`tenant-num-2-type`}
                    // value={formData?.numbers[1]?.number_type}
                    // onChange={(e) => {
                    //   setCreateLog({...createLog,number_type_2:1});
                    //   const phone = [...number];
                    //   phone[1].number_type = e.target.value;
                    //   setNumber(phone);
                    //   setFormData({ ...formData, numbers: phone });
                    // }}
                  >
                    <option value=" ">Select Type</option>
                    {/* {numberType?.map((row)=>(
                          <option value={row?.id}>{row?.type}</option>
                        ))} */}
                  </select>
                </div>
              </div>
              <div className="md:flex md:items-center mt-3">
                <div className="md:w-1/5">
                  <label className="block capitalize tracking-wide text-gray-700 font-bold mb-2">
                    Number 3:
                  </label>
                </div>
                <div className="md:w-3/5">
                  {/* {formData?.numbers[2]?.number_type == 8 ? */}
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id={`tenant-num-3`}
                    type="tel"
                    placeholder="(999) 999-9999"
                    // value={number?.[2]?.phone_number}
                    // onChange={(e) => {
                    //   const phone = [...number];
                    //   setCreateLog({...createLog,phone_number_1:1});
                    //   phone[2].phone_number = e.target.value;
                    //   setNumber(phone);
                    //   setFormData({ ...formData, numbers: phone });
                    // }}
                    // maxLength={ownerSettings?.phone_number_format?.length}
                  />
                  {/* :
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id={`tenant-num-3`}
                    type="tel"
                    placeholder="(999) 999-9999"
                    // value={formatPhoneNumber(number?.[2]?.phone_number,ownerSettings?.phone_number_format)}
                    // onChange={(e) => {
                    //   const phone = [...number];
                    //   setCreateLog({...createLog,phone_number_1:1});
                    //   phone[2].phone_number = removeNonNumeric(e.target.value);
                    //   setNumber(phone);
                    //   setFormData({ ...formData, numbers: phone });
                    // }}
                    // maxLength={ownerSettings?.phone_number_format?.length}
                  />
                  } */}
                </div>
                <div className="md:w-1/5 pl-3">
                  <select
                    className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id={`tenant-num-3-type`}
                    // value={formData?.numbers[2]?.number_type}
                    // onChange={(e) => {
                    //   setCreateLog({...createLog,number_type_3:1});
                    //   const phone = [...number];
                    //   phone[2].number_type = e.target.value;
                    //   setNumber(phone);
                    //   setFormData({ ...formData, numbers: phone });
                    // }}
                  >
                    <option value=" ">Select Type</option>
                    {/* {numberType?.map((row)=>(
                          <option value={row?.id}>{row?.type}</option>
                        ))} */}
                  </select>
                </div>
              </div>

              <div className="md:flex md:items-center mt-3 mb-6">
                <div className="flex md:items-center w-full mr-1">
                  <div className="md:w-1/5">
                    <label className="block capitalize tracking-wide text-gray-700 font-bold mb-2">
                      Email:
                    </label>
                  </div>
                  <div className="md:w-4/5">
                    <input
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id={`email`}
                      type="email"
                      placeholder="john.doe@email.com"
                      // value={formData?.email}
                      // onChange={(e) => {
                      //   setCreateLog({...createLog,email:1});
                      //   setFormData({ ...formData, email: e.target.value });
                      // }}
                    />
                  </div>
                </div>
              </div>

              <div className="md:flex md:items-center mt-3">
                <div className="md:flex md:items-center w-full md:w-6/12 mb-6">
                  <div className="md:w-2/5">
                    <label className="block capitalize tracking-wide text-gray-700 font-bold mb-2">
                      Date of Birth:
                    </label>
                  </div>
                  <div className="md:w-1/2">
                    <DatePicker
                    // value={stringToDate(formData?.date_of_birth)}
                    // onChange={(e) => {
                    //   const date = formatDate(e);
                    //   setCreateLog({...createLog,date_of_birth:1});
                    //   setFormData({ ...formData, date_of_birth: date });
                    // }}
                    />
                  </div>
                </div>
                <div className="md:flex md:items-center w-full md:w-6/12 mb-6">
                  <div className="md:w-2/5">
                    <label className="block capitalize tracking-wide text-gray-700 font-bold mb-2">
                      Referred Form:
                    </label>
                  </div>
                  <div className="md:w-1/2">
                    <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    // value={stringToDate(formData?.date_of_birth)}
                    // onChange={(e) => {
                    //   const date = formatDate(e);
                    //   setCreateLog({...createLog,date_of_birth:1});
                    //   setFormData({ ...formData, date_of_birth: date });
                    // }}
                    />
                  </div>
                </div>
              </div>
              <div className="md:flex md:items-center mt-3">
                <div className="md:flex md:items-center w-full md:w-6/12 mb-6">
                  <div className="md:w-2/5">
                    <label className="block capitalize tracking-wide text-gray-700 font-bold mb-2">
                      Gender:
                    </label>
                  </div>
                  <div className="md:w-1/2">
                    <select
                      className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      // value={stringToDate(formData?.date_of_birth)}
                      // onChange={(e) => {
                      //   const date = formatDate(e);
                      //   setCreateLog({...createLog,date_of_birth:1});
                      //   setFormData({ ...formData, date_of_birth: date });
                      // }}
                    >
                      <option value="">Select</option>
                    </select>
                  </div>
                </div>
                <div className="md:flex md:items-center w-full md:w-6/12 mb-6">
                  <div className="md:w-2/5">
                    <label className="block capitalize tracking-wide text-gray-700 font-bold mb-2">
                      Ethnicity:
                    </label>
                  </div>
                  <div className="md:w-1/2">
                    <select
                      className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      // value={stringToDate(formData?.date_of_birth)}
                      // onChange={(e) => {
                      //   const date = formatDate(e);
                      //   setCreateLog({...createLog,date_of_birth:1});
                      //   setFormData({ ...formData, date_of_birth: date });
                      // }}
                    >
                      <option value="">Select</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="md:flex md:items-center mt-3">
                <div className="md:flex md:items-center w-full md:w-6/12 mb-6">
                  <div className="md:w-2/5">
                    <label className="block capitalize tracking-wide text-gray-700 font-bold mb-2">
                      Pictures:
                    </label>
                  </div>
                  <div className="md:w-1/2">
                    <label className="block appearance-none text-center w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 cursor-pointer">
                      <span className="text-transparent bg-clip-text bg-gradient-to-r to-sky-700 from-sky-400 hover:bg-sky-500">
                        Upload Pictures
                      </span>
                      <input
                        // accept={picTypes}
                        id={`dl/id-pic`}
                        type="file"
                        hidden={true}
                        // onChange={async (e) => {
                        //   let file = e.target.files[0];
                        //   const reader = new FileReader();
                        //   reader.addEventListener("load", async () => {
                        //     const imgBase64 = reader.result;
                        //     try {
                        //       console.log(imgBase64);
                        //       const res = await ApiRequest.post(
                        //         "/public/api/auth/upload-image",
                        //         { image: imgBase64 }
                        //       );
                        //       // console.log("res", res?.data?.data?.image);
                        //       // formData?.dl_id_picture = res?.data?.data?.image
                        //       setCreateLog({...createLog,dl_id_picture:1});
                        //       setFormData({
                        //         ...formData,
                        //         dl_id_picture: res?.data?.data?.image,
                        //       });
                        //       // setDlidPicture(res?.data?.data?.image)
                        //       // setFeatureIcon(res?.data?.data?.image);
                        //     } catch (err) {
                        //       console.log(err);
                        //     }
                        //   });
                        //   reader.readAsDataURL(file);
                        //   const pictureWithURL = getImagesAndURLs(e)[0];
                        //   setDlidPicture(pictureWithURL);

                        //   // console.log("here 142");
                        //   // const pictures = [...propertyAssistantPictures];
                        //   // pictures[index] = getImagesAndURLs(e)[0];
                        //   // setPropertyAssistantPictures(pictures);
                        //   // setPropertyContacts(contacts);
                        //   // setFormData({...formData, contacts : contacts})
                        // }}
                      />
                    </label>
                  </div>
                </div>
              </div>
              {/* {dlidPicture[0]?.pictures?.picture != null ? (
                <section className="overflow-hidden w-full text-gray-700 mt-4 ml-[19%]">
                  <div className="container w-full">
                    <div
                      id="image-block"
                      className="flex flex-wrap justify-start w-full -m-1 md:-m-2"
                    >
                      {imageComponent({
                        image: dlidPicture?.image?.picture,
                        src: dlidPicture?.url,
                        inputFieldId: "dlid-picture",
                        trashAble: true,
                        onTrashClick: () => {
                          formData.dl_id_picture = null;
                          setDlidPicture(null);
                        },
                      })}
                    </div>
                  </div>
                </section>
              ) : null} */}
            </div>
          </div>
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
            <PropertyNotifications/>
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
          <div className="md:items-center w-full mt-4">
            <div className="flex">
              <img
                className="logo w-12 mr-5"
                src="/assets/svgs/system-notes-and-files.svg"
                alt=""
              />
              <label className="block capitalize tracking-wide text-gray-700 text-xl font-bold mb-2">
                Notes & Files:
              </label>
            </div>
          </div>
          <div className="md:flex flex-column md:items-center w-[90%] m-auto">
            <div className="w-full">
              <FolderStructure />
              <Notes />
            </div>
          </div>
        </TabPanel>
        <TabPanel value={tabValue} index={3}>
            <Interactions/>
        </TabPanel>
      </form>
    </>
  );
};
